export default __webpack_public_path__ + "static/tplo-dog-v5-90c64c6e8ef9690b535888d010f498d5.png";